(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-list"] && !Shopify.designMode) return;
  try {
    class FaqSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-faq-input]');
      if (!this.input) return;
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.chips = [...this.querySelectorAll('[data-faq-chip]')];
      this.empty = this.querySelector('[data-faq-empty]');
      this.status = this.querySelector('[data-faq-status]');
      this.input.addEventListener('input', () => this.filter());
      const initial = new URLSearchParams(window.location.search).get('q');
      if (initial) {
        this.input.value = initial;
        this.filter();
      }
    }

    filter() {
      const terms = this.input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      let visible = 0;
      this.items.forEach((item) => {
        const match = terms.every((term) => item.dataset.faqText.includes(term));
        item.hidden = !match;
        if (match) visible += 1;
      });
      this.groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
      });
      this.chips.forEach((chip) => {
        chip.hidden = Boolean(document.getElementById(chip.dataset.faqChip)?.hidden);
      });
      if (this.empty) this.empty.hidden = visible > 0;
      if (this.status) this.status.textContent = terms.length ? this.status.dataset.template.replace('{count}', visible) : '';
    }
  }
  if (!customElements.get('faq-search')) customElements.define('faq-search', FaqSearch);
  } catch(e) { console.error(e); }
})();

})();
